/**
 * Keyed by column id; shared by the member table and its skeleton. Fixed percentages (with the
 * table's fixed layout) spread spare width across every column instead of handing it all to the
 * name, and keep each column in the same place in every status group.
 */
export const TRUST_ACCOUNT_COLUMN_WIDTHS = {
  trustName: '22%',
  balance: '19%',
  type: '13%',
  team: '13%',
  developer: '15%',
  createdAt: '18%'
} as const;

export const TRUST_ACCOUNT_TABLE_MIN_WIDTH = '64rem';

/** `embedded` gives the fixed layout but no frame, so the list draws the frame around it. */
export const TRUST_ACCOUNT_TABLE_FRAME_CLASS =
  'overflow-hidden rounded-xl border border-border bg-background-surface shadow-xs';
